import SeasonalPaywall, {
  SeasonalPaywallColors,
} from "../SeasonalPaywall/SeasonalPaywall"
import useStrings from "../../localization/useStrings"
import { useBlackFriday } from "../../context/blackFridayContext"
import svg from "../../utils/svg"
import styles from "./SpringPaywall.module.scss"

const springColors: SeasonalPaywallColors = {
  scrollableGradient: "#E9EAEC",
  header: {
    background: "linear-gradient(135deg, #E9EAEC 0%, white 100%)",
    title: "#58595B",
    tagline: "#EB97A8",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.16)",
    border: "1px solid white",
    borderRadius: "16px",
    margin: "0 24px",
  },
  countdown: {
    boxBackground: "white",
    value: "#58595B",
    unit: "#8D8D8D",
    label: "#8D8D8D",
  },
  content: {
    background: "#E9EAEC",
    ultimateContainerBackground: "#EA8998",
    ultimateContainerText: "white",
  },
  features: {
    icon: "#EA8998",
    title: "#58595B",
    description: "#8D8D8D",
  },
  footer: {
    background: "#E9EAEC",
    boxShadow: "0 -4px 12px 4px rgba(0, 0, 0, 0.16)",
    borderTop: "1px solid white",
    borderRadius: "16px 16px 0 0",
    primaryButton: {
      background: "#EA8998",
      headerBackground: "#EA8998",
      contentBackground: "white",
      limitedTimeText: "white",
      saveTagText: "white",
      planTitle: "#58595B",
      duration: "#58595B",
      originalPrice: "rgba(88, 89, 91, 0.6)",
      discountedPrice: "rgba(88, 89, 91, 0.6)",
      monthlyRate: "#58595B",
    },
    monthlyButton: {
      background: "white",
      border: "1px solid #E5E5E5",
      label: "#58595B",
      price: "#58595B",
    },
  },
  insets: {
    header: "white",
    footer: "#E9EAEC",
  },
}

const SpringPaywall = () => {
  const strings = useStrings()
  const { state } = useBlackFriday()

  return (
    <SeasonalPaywall
      headerSpacing="8px"
      colors={springColors}
      topDecoration={
        <div className={styles.top}>
          <svg.spring.SpringHeader />
        </div>
      }
      footerBackground={<div style={{ height: 12 }} />}
      strings={{
        title: strings.springSale.title,
        tagline: state.isPremiumUser
          ? strings.springSale.ultimateTagline
          : strings.springSale.tagline,
        buttonTitle: strings.springSale.buttonTitle,
      }}
    />
  )
}

export default SpringPaywall
